// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.header[data-v-14384add]{position:relative;width:100%;background-color:transparent}.header .container .inner[data-v-14384add]{width:100%;max-width:1696px;margin:auto;display:flex;grid-gap:2rem;gap:2rem}.header--logo[data-v-14384add]{flex-grow:1;display:flex;align-items:center;justify-content:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
